import React, { FC, useEffect } from 'react';
import Auth from '@aws-amplify/auth';

import { useGlobalClient } from 'hooks';
import { Loaders } from 'components';

import AuthError from './AuthError';

const SSO: FC = () => {
  const client = useGlobalClient();
  const { sso_configuration } = client;

  const urlParams = new URLSearchParams(window.location.search);
  const isSSOUserDisabled = urlParams.get('code') && urlParams.get('state');

  useEffect(() => {
    if (!isSSOUserDisabled) {
      const { provider } = sso_configuration;
      void Auth.federatedSignIn({ customProvider: provider });
    }
  }, []);

  if (isSSOUserDisabled) {
    return <AuthError code="user_profile_suspended" />;
  }

  return <Loaders.Startup />;
};

export default SSO;
